export const inTheNewsAddComponent = {

    //passing title and onSubmit function for binding in main component
    template: `
            <in-the-news-main 
                page-title='Add News'
                parent-slug='{{$ctrl.parentSlug}}' 
                disable-buttons='$ctrl.disableButtons'
                on-submit='$ctrl.onSubmit(details)'
                on-save-publish='$ctrl.onSavePublish(details)'
                show-republish-button='$ctrl.showRepublishButton'
                show-save-publish-type-button='$ctrl.showSavePublishTypeButton'>
            </in-the-news-main>`,

    bindings: {
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for InTheNewsAddComponent
    controller: class InTheNewsAddComponent {
        constructor($stateParams, toastr, $state, AboutUsService, DynamicMenusService, SlugService) {
            'ngInject';

            this.$stateParams = $stateParams;
            this.toastr = toastr;
            this.$state = $state;
            this.aboutUsService = AboutUsService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        $onInit() {
            this.showRepublishButton = false;
            this.showSavePublishTypeButton = true;
        }

        //function to add class details
        onSubmit(details) {
            this.disableButtons = true;
            const url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
            details = this.aboutUsService._setNewsObject(details);

            // submit the request
            this.dynamicMenusService.addMenuDetailsByUrl(url, details)
                .then(({ data: { content_id: id } }) => {
                    const contentDetailsUrl = this.slugService.getContentDetailsURL(url, id);
                    this.toastr.success('News added successfully');
                    this._redirectToParentState(contentDetailsUrl);
                    this.disableButtons = false;
                }).catch((err) => {
                    this.toastr.error(err);
                    this.disableButtons = false;
                });
        }

        _redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/about-us/in-the-news/in-the-news-add/in-the-news-add.component.js